module.exports = __webpack_public_path__ + "img/gift.289ee97a.png";